<template>

  <b-modal size="xl" @hide="closeSearch()" ref="modal" :id="id"
           no-close-on-backdrop
           :title="'Buscar ' + personType.text" hide-footer>

    <b-row>

      <t-input cols="3" v-model="form.name" @keyup.enter.native="searchPersons" label="Nome"/>

      <t-input cols="2" v-model="form.federalTaxpayer" @keyup.enter.native="searchPersons" label="CNPJ/CPF"/>

      <t-input cols="2" v-model="form.city" @keyup.enter.native="searchPersons" label="Cidade"/>

      <b-col cols="2">
        <t-button @click="searchPersons" primary form-inline>
          <b-icon-search class="mr-1" style="scale: 0.8"></b-icon-search>
          Filtrar
        </t-button>
      </b-col>

      <b-col cols="2" v-if="personType.path === 'customer'">
        <t-button @click="openCustomerForm" form-inline>
          <b-icon-plus-circle class="mr-1" style="scale: 0.8"></b-icon-plus-circle>
          Cadastrar Novo
        </t-button>
      </b-col>


    </b-row>

    <div style="overflow: hidden; position: relative; float: left; width: 100%">
      <t-table
          @getPage="getPageSearchPerson"
          :show="checkViewListTableDefault()"
          :filtered="filtered"
          :busy="!pageListIsLoaded"
          :user-auth="userAuth"
          :items="request.content"
          :fields="fields"
          :total-pages="request.totalPages"
          :total-elements="request.totalElements"
          :container-table-style="[{'min-height':'250px'}]"
          :title-items="personType.text + 's'"
          :link-primary-column="personType.personNumber"
          table-bordered
          table-striped
          disable-actions-column
          :primary-key-column="personType.personId">

        <template #first-column="{item}">
          <b-link @click="selectPerson(item[personType.personId])">{{
              item[personType.personNumber] | lpad(4)
            }}
          </b-link>
        </template>

      </t-table>
    </div>

  </b-modal>

</template>
<script>

import EntityPersonType from "@/model/types/modules/general/EntityPersonType";
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service"
import ui from "@/assets/scripts/ui";

export default {
  computed: {
    ui() {
      return ui
    }
  },
  mixins: [pageDefaultMixin, pageListMixin],
  name: 't-input-person-list',
  data() {
    return {
      id: "modal-person-search",
      personType: {},
      onSending: false,
      pagePersonSearch: 1,//Declara aqui para não conflitar com pageNumber externo
      searchParamsPerson: new URLSearchParams(), //declara aqui para não conflitar
      filtered: false,
      form: {
        name: "",
        federalTaxpayer: "",
        city: "",
      },
      fields: [],
    }
  },

  props: {
    show: Boolean,
    codeLabel: String,
    entityPersonType: Number,
  },
  watch: {

    show(v) {
      if (v) {
        this.searchPersons()
      }
    },
    codeLabel(v) {
      this.form.default = v
    }
  },
  methods: {

    mountedPrepare() {

      this.personType = EntityPersonType.list.find(a => a.value === this.entityPersonType)
      this.id += '-' + this.entityPersonType

      this.fields = [
        {key: this.personType.personNumber, label: 'Código'},
        {key: "name", label: "Nome Fantasia"},
        {key: "companyName", label: "Razão Social"},

        {key: "federalTaxpayer", label: "CNPJ/CPF"},
        {key: "cityFull", label: "Cidade/UF", columns: 5},
      ]


      this.searchParamsPerson.append('pageSize', "10")

    },
    async mountedContinued() {


      this.pageListIsLoaded = true


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    closeSearch() {
      this.$emit("onClose")
    },

    openCustomerForm() {
      ui.goPath(this,'/customer/new','',true)
    },

    async searchPersons() {

      this.filtered = true

      Object.keys(this.form).forEach(key => {

        this.searchParamsPerson.delete(key)

        if (this.form[key] !== '' && this.form[key] !== 0) {
          this.searchParamsPerson.append(key, this.form[key])
        }

      })

      await this.getPageSearchPerson(1)


    },

    async getPageSearchPerson(pageNumber, finishLoaded = true) {

      this.pageListIsLoaded = false

      //DEVERÁ MONTAR OS PARÂMETROS DINAMICAMENTE CONFORME OS CAMPOS FOREM MARCADOS COMO DE PESQUISA
      await crudGeneral.getAll(this.personType.path, pageNumber, this.searchParamsPerson)
          .then(response => {

            this.request = response.data

            if (finishLoaded)
              this.pageListIsLoaded = true

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          })


    },


    changeName() {
      this.pageListIsLoaded = false
      this.timeSearchSend(() => this.searchPersons())
      /*this.getFieldsCustomizable('model')*/
    },


    selectPerson(id) {

      if (id > 0) {
        this.$bvModal.hide(this.id)
        this.$emit("onSelected", id)
      }

    }
    //--------------------------------------------------------------------------------------
  },


  async mounted() {

    this.mountedPrepare()

    await this.getPageSearchPerson(this.pagePersonSearch, false)

    await this.mountedContinued()

  },

}
</script>